module.exports = __webpack_public_path__ + "img/logo.760592ee.png";